import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { fetchReceiveHistoryDetailRecord, editReceiveHistory, resetEditReceiveHistory } from '../../actions/receive_actions';
import { setValue } from '../../actions/sales_actions';
import { setDefaultSearchType, setDefaultOfForm, resetAllProducts } from '../../actions/purchaseOrders_actions';
import { printWarehouseReceive } from '../../actions/print_actions';
import { fetchProductsByVendor, fetchProductInfo, fetchSimplifiedProducts } from '../../actions/products_actions';
import ReceiveHistoryDetail from '../../components/Inventories/receiveHistoryDetail';

const receiveHistoryDetail = reduxForm({
  form: 'receiveHistoryDetail',
})(ReceiveHistoryDetail);

const selector = formValueSelector('receiveHistoryDetail');

function mapStateToProps(state) {
  const HandlingCost = selector(state, 'HandlingCost');
  const MiscCost = selector(state, 'MiscCost');
  const ShippingCost = selector(state, 'ShippingCost');
  const priceAdjustment = selector(state, 'PriceAdjustment');
  const InvoiceFinalPrice = selector(state, 'InvoiceFinalPrice');
  const TaxRate = selector(state, 'TaxRate');
  const TotalCRV = selector(state, 'TotalCRV');
  const quantityValue = selector(state, 'Quantity');
  const searchType = selector(state, 'searchType');
  const customerChosen = selector(state, 'customerChosen');
  const unitPrice = selector(state, 'unitPrice');
  const remark = selector(state, 'itemNotation');
  const weight = selector(state, 'Weight');

  return {
    HandlingCost,
    MiscCost,
    ShippingCost,
    priceAdjustment,
    InvoiceFinalPrice,
    TaxRate,
    TotalCRV,
    quantityValue,
    searchType,
    customerChosen,
    unitPrice,
    remark,
    weight,
    currentReceiveHistory: state.receives.currentReceiveHistory,
    currentReceiveHistoryDetail: state.receives.fetchedReceiveHistoryDetailRecord,
    detailIsLoading: state.receives.isfetchingReceiveHistoryDetail,
    error: state.receives.fetchReceiveHistoryDetailError,
    initialValues: state.receives.fetchedReceiveHistoryDetailRecord,

    isEditingReveiveHistory: state.receives.isEditingReveiveHistory,
    editedReceiveHistory: state.receives.editedReceiveHistory,

    simplifiedProducts: state.products.simplifiedProducts,
    simplifiedProductsIsLoading: state.products.simplifiedProductsIsLoading,
    simplifiedProductsError: state.products.simplifiedProductsError,

    taxRates: state.salesOrders.taxRates,
    taxRatesIsLoading: state.salesOrders.taxRatesIsLoading,
    taxRatesError: state.salesOrders.taxRatesError,

    purchaseOrderProduct: state.purchaseOrders.purchaseOrderProduct,
    purchaseOrderProductIsLoading: state.purchaseOrders.purchaseOrderProductIsLoading,
    purchaseOrderProductError: state.purchaseOrders.purchaseOrderProductError,
    requestingWarehouseReceivePdf: state.print.requestingWarehouseReceivePdf,
    warehouseReceivePdf: state.print.warehouseReceivePdf,

  };
}

export default connect(mapStateToProps, {
  editReceiveHistory,
  fetchProductInfo,
  fetchProductsByVendor,
  fetchReceiveHistoryDetailRecord,
  fetchSimplifiedProducts,
  printWarehouseReceive,
  resetAllProducts,
  resetEditReceiveHistory,
  setDefaultOfForm,
  setDefaultSearchType,
  setValue,
})(receiveHistoryDetail);



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/receiveHistoryDetail.jsx